import React from 'react'
import { Card, CardDescription, CardHeader, CardTitle } from '../ui/card'
import { MessageCircle } from 'lucide-react'

interface BrandMessagingTabProps {
  onToolboxItemSelect: (itemId: string) => void
}

export function BrandMessagingTab({ onToolboxItemSelect }: BrandMessagingTabProps) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Brand Messaging</h2>
        <p className="text-slate-600">Develop your brand voice, tone, and communication strategy</p>
      </div>
      
      <Card 
        className="cursor-pointer hover:shadow-lg transition-shadow" 
        onClick={() => onToolboxItemSelect('voice-tone')}
      >
        <CardHeader className="p-[21px]">
          <CardTitle className="flex items-center gap-3">
            <MessageCircle className="w-6 h-6 text-blue-500" />
            Voice & Tone Guide
          </CardTitle>
          <CardDescription>
            Define how your brand communicates and sounds
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  )
}